class Dispatcher {
    constructor() {
        this.cbs = {};
    }
    listen(key, callback) {
        if (!key || !callback) {
            return;
        }
        if (!this.cbs[key]) {
            this.cbs[key] = [];
        }
        this.cbs[key].push(callback);
    }
    remove(key, callback) {
        if (!this.cbs[key]) {
            return;
        }
        if (!callback) {
            delete this.cbs[key];
            return;
        }
        const index = this.cbs[key].findIndex(callback);
        if (index < 0) {
            this.cbs[key].splice(index, 1);
        }
    }
    trigger(key, ...args) {
        const fns = this.cbs[key];
        if (!fns || fns.length === 0) {
            return;
        }
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < fns.length; i++) {
            fns[i].apply(this, args);
        }
    }
}
export default Dispatcher;
